var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHamburgerDefault = function SvgHamburgerDefault(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 89 89",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M85.043 25.752H3.906a2.67 2.67 0 0 1 0-5.342h81.137a2.67 2.67 0 1 1 0 5.342ZM85.043 47.577H3.906a2.67 2.67 0 1 1 0-5.342h81.137a2.67 2.67 0 1 1 0 5.342ZM85.043 69.403H3.906a2.67 2.67 0 0 1 0-5.342h81.137a2.67 2.67 0 0 1 0 5.342Z",
    fill: "currentColor"
  })));
};
export { SvgHamburgerDefault as ReactComponent };
export default __webpack_public_path__ + "2fefe36e754e8d772f56973422423ea6.svg";